import { render, staticRenderFns } from "./OrdersFBACreationUser.vue?vue&type=template&id=c86f0ae6&scoped=true"
import script from "./OrdersFBACreationUser.vue?vue&type=script&lang=js"
export * from "./OrdersFBACreationUser.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBACreationUser.vue?vue&type=style&index=0&id=c86f0ae6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c86f0ae6",
  null
  
)

export default component.exports